module.exports = __webpack_public_path__ + "static/media/sidebar-create-school.f8b2f71b.svg";